<template>
  <button
    id='developerWarning'
    v-if='$store.state.isDevelopment'
    @click='showAlert()'
    :style="{
      position: 'absolute',
      bottom: '0px',
      right: '0px',
      zIndex: 10,
      backgroundColor: 'yellow',
      display: hideWarning ? 'none' : 'block' }">
    DEVELOPER VERSION
  </button>
</template>

<script >
    export default {
        data() {
            return { hideWarning: false }
        },
        methods: {
          showAlert() {
            console.log("FARTS");
            window.alert("Use: \"npm run build\" to build a dist directory for production.");
            this.hideWarning = true;
          }
        }
    }
</script>

